import React, { Fragment } from "react";
import Image from "react-bootstrap/Image";
import { Row, Col } from "react-bootstrap";
import StudentController from "../api/StudentController";

interface StudentProfileViewProps
{
    data: Student;
}

interface StudentProfileViewState
{
    imageDataUrl: string | null;
}

export default class StudentProfileView extends React.Component<StudentProfileViewProps, StudentProfileViewState>
{
    studentController: StudentController;

    constructor(props: StudentProfileViewProps)
    {
        super(props);
        this.studentController = new StudentController();
        this.state = {
            imageDataUrl: null
        };
    }

    async componentDidMount(): Promise<void>
    {
        if (this.props.data?.imageURL) {
            await this.fetchImageWithAuth();
        }
    }

    async componentDidUpdate(prevProps: StudentProfileViewProps): Promise<void>
    {
        if (prevProps.data?.imageURL !== this.props.data?.imageURL && this.props.data?.imageURL) {
            await this.fetchImageWithAuth();
        }
    }

    async fetchImageWithAuth(): Promise<void>
    {
        try {
            const accessToken = await this.studentController.authService.getAccessToken();
            const imageUrl = `${this.studentController.baseUrl + this.props.data.imageURL}`;

            const response = await fetch(imageUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const dataUrl = URL.createObjectURL(blob);
                this.setState({ imageDataUrl: dataUrl });
            } else {
                console.error('Failed to fetch image:', response.status);
            }
        } catch (error) {
            console.error('Error fetching image with auth:', error);
        }
    }

    componentWillUnmount(): void
    {
        // Clean up the object URL to prevent memory leaks
        if (this.state.imageDataUrl && this.state.imageDataUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.state.imageDataUrl);
        }
    }

    render(): React.ReactNode
    {

        return <Fragment>
            <Row className="align-items-center studentProfileView">
                <Col className={"student-image"} lg={1}>
                    {this.state.imageDataUrl &&
                        <Image src={this.state.imageDataUrl} roundedCircle />
                    }
                </Col>
                <Col>
                    <div className={"student-info"}>
                        <h1>{this.props.data.fullName}</h1>
                        <div className={"student-major"}>{this.props.data.majors.join(", ")} <b>Year {this.props.data.year}</b></div>
                    </div>
                </Col>
            </Row>
        </Fragment>;
    }
}